import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import { countryAtom, setGlobalCountry } from '@/atoms/countryState';

const GlobalCountrySync = () => {
  const { selectedCountry } = useRecoilValue(countryAtom);

  useEffect(() => {
    if (selectedCountry) {
      setGlobalCountry(
        selectedCountry.code,
        selectedCountry.phoneCode,
        selectedCountry.countryId,
        selectedCountry.name,
        selectedCountry.currency,
        selectedCountry.currency_symbol,
        selectedCountry.timezone || 'Asia/Kolkata',
      );
    } else {
      setGlobalCountry(null, null, null, null, null, null, null);
    }
  }, [selectedCountry]);

  return null;
};

export default GlobalCountrySync;
